// ID-080: inches-only dimension display. Tile size and mesh sheet are always labelled separately.
const parse = (s, assumeInches) => {
  const t = String(s || "").trim().toLowerCase().replace(/×/g, "x");
  if (!t || /mm|cm/.test(t)) return null;
  const m = t.match(/^(\d+(?:\.\d+)?)\s*(?:"|in|inch|inches)?\s*x\s*(\d+(?:\.\d+)?)\s*("|in|inch|inches)?$/);
  if (!m || !(assumeInches || /"|in/.test(t))) return null;
  return `${Number(m[1])}" × ${Number(m[2])}"`;
};

export const tileSize = (v) => v?.tile_size_in || parse(v?.format_in, /^\d{1,2}x\d{1,2}$/.test(String(v?.format_in || ""))) || null;
export const meshSize = (v) => v?.mesh_sheet_in || parse(v?.mesh_sheet_dims, false) || null;

export const dimsLine = (v) => {
  const t = tileSize(v);
  const m = (v?.presentation || v?.mounting) === "Mesh-mounted" || v?.mesh_sheet_in ? meshSize(v) : null;
  return [t ? `Tile ${t}` : "Tile size not set", m && `Mesh sheet ${m}`].filter(Boolean).join(" · ");
};
